import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-navbar-secretaire',
  templateUrl: './navbar-secretaire.component.html',
  styleUrls: ['./navbar-secretaire.component.scss']
})
export class NavbarSecretaireComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
